module.exports = __webpack_public_path__ + "img/V-63-ER-1200-BB.fd81b912.png";